export default {
  primary: '#ffc20d',
  secondary: '#56ccf7',
  danger: '#ff6674',
  gray: '#9099a5',
  lightGray: '#dbdfe4',
  darkGray: '#525960'
}
